import { FaSquareFacebook, FaSquareInstagram, FaCcPaypal, FaCcVisa, FaCcMastercard, FaCcDiscover } from "react-icons/fa6";

const Footer = () => {

    return (
        <div className=" bg-tripstore-black/60 py-6 text-white">
            <div className=" w-[95%] m-auto">
                <div className=" flex justify-between gap-4 flex-wrap *:w-[250px]">

                    <div className="">
                        <div className=" text-nowrap text-primary font-semibold text-lg mb-2">Need Help?</div>
                        <div className=" *:text-nowrap *:block *:my-1 hover:*:underline">
                            <a href="#/">Chat with us</a>
                            <a href="#/">Help Center</a>
                            <a href="#/">Contact Us</a>
                        </div>
                    </div>

                    <div className="">
                        <div className=" text-nowrap text-primary font-semibold text-lg mb-2">Categories</div>
                        <div className=" *:text-nowrap *:block *:my-1 hover:*:underline">
                            {
                                Object.values(category).map((item, index) => (
                                    <a key={index} href="#/">{item}</a>
                                ))
                            }
                        </div>
                    </div>

                    <div className="">
                        <div className=" text-nowrap text-primary font-semibold text-lg mb-2">Quick Links</div>
                        <div className=" *:text-nowrap *:block *:my-1 hover:*:underline">
                            <a href="#/">About Us</a>
                            <a href="#/">Terms and Conditions</a>
                            <a href="#/">Privacy Notice</a>
                            <a href="#/">Return Policy</a>
                        </div>
                    </div>

                    <div className="">
                        <div className=" text-nowrap text-primary font-semibold text-lg mb-2">Address</div>
                        <div className=" *:my-1">
                            <div className="">Address: Flat 1-2 7 Market Pace, Saffron Walden, England, CB10 1HR</div>
                            <div className=" text-nowrap">Phone: (+44) 701 6801 103</div>
                            <div className=" text-nowrap">E-mail: info@tripstore.com</div>
                        </div>
                    </div>

                </div>

                <div className=" flex flex-wrap *:w-[300px] justify-between gap-4 mt-8">

                    <div className=" flex gap-4 items-center *:cursor-pointer text-2xl">
                        <a href="#/" className=""><FaSquareFacebook /></a>
                        <a href="#/" className=""><FaSquareInstagram /></a>
                    </div>

                    <div className=" flex items-center gap-4 *:cursor-pointer text-2xl">
                        <a href="#/" className=""><FaCcPaypal /></a>
                        <a href="#/" className=""><FaCcVisa /></a>
                        <a href="#/" className=""><FaCcMastercard /></a>
                        <a href="#/" className=""><FaCcDiscover /></a>
                    </div>

                    <div className="">
                        <div className="">Copyright &#169; {new Date().getFullYear()} Tripstore.</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer

const category = {
    healthAndBeauty: 'health & beauty',
    homeAndOffice: 'home & office',
    appliances: 'appliances',
    phonesAndTablets: 'phones & tablets',
    computing: 'computing',
    electronics: 'electronics',
    fashion: 'fashion',
    babyProducts: 'baby products',
    gaming: 'gaming',
    sportingGoods: 'sporting goods'
}